import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Chevron down SVG Icon for scroll to bottom of chat button.
 */
export const ChevronDown: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M13.8125 4H12.6406C12.5609 4 12.4859 4.03906 12.439 4.10313L7.99995 10.2219L3.56089 4.10313C3.51402 4.03906 3.43902 4 3.35933 4H2.18745C2.08589 4 2.02652 4.11563 2.08589 4.19844L7.59527 11.7937C7.79527 12.0687 8.20464 12.0687 8.40308 11.7937L13.9125 4.19844C13.9734 4.11563 13.914 4 13.8125 4Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
